import {type FC, useEffect, useMemo} from 'react';

import {Observer} from 'mobx-react';

import {useI18n} from '@yourcoach/i18n';

import type {TextAnswerModel} from '../../../../../../../core/domain/Answer/TextAnswer/TextAnswer.model';
import type {TextQuestionModel} from '../../../../../../../core/domain/Question/TextQuestion/TextQuestion.model';
import type {GetComponentProps} from '../../../../../../../utils/utility-types';
import type {QuestionProps} from '../types';

import {TextAnswerFactory} from '../../../../../../../core/domain/Answer/TextAnswer/TextAnswerFactory';
import {useInjection} from '../../../../../../../IoC';
import {TextInput} from '../../../../../../../uikit/TextInput';

export const TextQuestion: FC<
  QuestionProps<TextQuestionModel, TextAnswerModel>
> = ({answer: answerProp, onAnswerChange, question}) => {
  const {t} = useI18n();
  const answerFactory = useInjection(TextAnswerFactory);

  const answer = useMemo(() => {
    return (
      answerProp ??
      answerFactory.create({
        question,
        value: '',
      })
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!answerProp) {
      onAnswerChange?.(answer);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onChange: GetComponentProps<typeof TextInput>['onChange'] = action => {
    answer.onChange(action);
  };

  return (
    <Observer>
      {() => (
        <TextInput
          error={answer.field.error ?? ''}
          onChange={onChange}
          placeholder={t('shared:enter_your_answer_here')}
          value={answer.field.value}
        />
      )}
    </Observer>
  );
};
